__turbopack_context__.v({
  "createRow": "StVyxW_createRow",
  "createText": "StVyxW_createText",
  "description": "StVyxW_description",
  "groupHeading": "StVyxW_groupHeading",
  "leadBadge": "StVyxW_leadBadge",
  "mailBadge": "StVyxW_mailBadge",
  "optionAvatar": "StVyxW_optionAvatar",
  "optionDescription": "StVyxW_optionDescription",
  "optionName": "StVyxW_optionName",
  "optionNameRow": "StVyxW_optionNameRow",
  "optionRow": "StVyxW_optionRow",
  "optionText": "StVyxW_optionText",
  "row": "StVyxW_row",
  "rowAvatar": "StVyxW_rowAvatar",
  "rowMail": "StVyxW_rowMail",
  "rowName": "StVyxW_rowName",
  "rowRemove": "StVyxW_rowRemove",
  "rowRole": "StVyxW_rowRole",
  "rowText": "StVyxW_rowText",
  "suggestAvatar": "StVyxW_suggestAvatar",
  "suggestBlock": "StVyxW_suggestBlock",
  "suggestChip": "StVyxW_suggestChip",
  "suggestLabel": "StVyxW_suggestLabel",
  "suggestName": "StVyxW_suggestName",
  "suggestPlus": "StVyxW_suggestPlus",
  "suggestRole": "StVyxW_suggestRole",
  "suggestText": "StVyxW_suggestText",
  "valueContainer": "StVyxW_valueContainer",
});
